// English strings for the operations views stream (PD-555 – PD-569): integration health on the
// Operations page (PB-19-08), recovery evidence on recent runs (PB-19-06), the visit-level access
// events panel (PB-11-08) and configuration promotion (PB-19-09). Arabic: ar-opsview.ts.
export const enOpsview = {
  // ---------------------------------------------------------------- integration health (PB-19-08)
  'opv.health.title': 'Devices and integrations',
  'opv.health.sub': 'Counts by state in your scope. Connection and business results are separate facts: a connected device can still have an unknown or failed result.',
  'opv.health.devices': 'Device connectivity',
  'opv.health.devicesSub': 'Paired devices and kiosks, by heartbeat against each device’s stale window.',
  'opv.health.heartbeat': 'Last heartbeat',
  'opv.health.lastJob': 'Last device job',
  'opv.health.connectors': 'Connectors',
  'opv.health.connectorsSub': 'Transport and business health of enabled connectors.',
  'opv.health.transport': 'Transport',
  'opv.health.business': 'Business results',
  'opv.health.edge': 'Edge agents',
  'opv.health.poll': 'Access-event polls',
  'opv.health.pollSub': 'Last poll per active access connector. Unknown means the provider did not answer; nothing was assumed.',
  'opv.health.kind': 'Kind',
  'opv.health.total': 'Total',
  'opv.health.empty': 'No devices or connectors in this scope.',
  'opv.conn.connected': 'Connected',
  'opv.conn.degraded': 'Degraded',
  'opv.conn.disconnected': 'Not heard from',
  'opv.conn.never_connected': 'Never connected',
  'opv.conn.pending': 'Not paired yet',
  'opv.kind.printer': 'Badge printers',
  'opv.kind.scanner': 'Scanners',
  'opv.kind.reader': 'Readers',
  'opv.kind.encoder': 'Card encoders',
  'opv.kind.edge_agent': 'Edge agents',
  'opv.kind.kiosk': 'Kiosks',
  'opv.age.under_1m': 'Under 1 minute',
  'opv.age.1m_to_5m': '1–5 minutes',
  'opv.age.5m_to_15m': '5–15 minutes',
  'opv.age.15m_to_1h': '15–60 minutes',
  'opv.age.over_1h': 'Over 1 hour',
  'opv.age.never': 'Never',
  'opv.job.completed': 'Completed',
  'opv.job.failed': 'Failed',
  'opv.job.unknown': 'Unknown — check the device',
  'opv.job.none': 'No job yet',
  'opv.status.draft': 'Draft',
  'opv.status.enabled': 'Enabled',
  'opv.status.disabled': 'Disabled',
  'opv.biz.confirmed': 'Confirmed',
  'opv.biz.attention': 'Failed in the last 24 hours',
  'opv.biz.unknown': 'Unknown outcome to reconcile',
  'opv.biz.none': 'No results yet',
  'opv.edge.enrolled': 'Enrolled and active',
  'opv.edge.buffer_dropped': 'Dropped buffered events',
  'opv.edge.commands_unknown': 'With unknown command results',
  'opv.edge.commands_pending': 'With commands waiting',
  'opv.edge.bufferedEvents': 'Events buffered on agents',
  'opv.poll.ok': 'Succeeded',
  'opv.poll.unknown': 'Unknown (no answer)',
  'opv.poll.failed': 'Failed',

  // ---------------------------------------------------------------- recovery evidence (PB-19-06)
  'opv.runs.evidence': 'Recovery evidence',
  'opv.runs.backupVerified': 'Restore rehearsed',
  'opv.runs.backupUnverified': 'Not verified — no successful restore of this backup',
  'opv.runs.restoreVerified': 'Restore verified',
  'opv.runs.restoreFailed': 'Restore not verified',
  'opv.runs.notApplicable': 'Not applicable',
  'opv.runs.note': 'A successful backup is not evidence of recoverability until a restore of the same backup has been rehearsed and verified.',

  // ---------------------------------------------------------------- visit access events (PB-11-08)
  'opv.visitEvents.title': 'Access events',
  'opv.visitEvents.sub': 'Door and zone events reported by the access-control system for this visit, by when they happened. They are provider facts and do not change presence.',

  // ---------------------------------------------------------------- configuration promotion (PB-19-09)
  'opv.promo.link': 'Configuration promotion',
  'opv.promo.title': 'Configuration promotion',
  'opv.promo.intro': 'Export this organisation’s portable settings, or check a bundle from another environment and see what it would change here. Nothing is applied from this page.',
  'opv.promo.facts': 'This environment',
  'opv.promo.environment': 'Environment',
  'opv.promo.schema': 'Schema version',
  'opv.promo.format': 'Bundle format',
  'opv.promo.signing': 'Signing key',
  'opv.promo.signingNone': 'Not configured — exports are unsigned and signed bundles cannot be verified here',
  'opv.promo.apply': 'Applying a bundle',
  'opv.promo.applyNone': 'Not available here. Make reviewed changes through the normal administration screens; automated apply and rollback wait for an owner decision.',
  'opv.promo.export': 'Export',
  'opv.promo.exportSub': 'Sites, coded locations, published visitor policies, security-policy limits and brand colours. Never accounts, people, contact details, files or secrets. Each export is audited.',
  'opv.promo.exportButton': 'Export bundle',
  'opv.promo.download': 'Download bundle file',
  'opv.promo.check': 'Check a bundle',
  'opv.promo.checkSub': 'Choose a bundle file. It is validated (format, checksum, signature, portable content) and planned against this organisation as a dry run.',
  'opv.promo.file': 'Bundle file',
  'opv.promo.fileInvalid': 'This file is not valid JSON.',
  'opv.promo.allowUnsigned': 'Review an unsigned bundle (dry run only)',
  'opv.promo.mapping': 'Reference mapping (optional)',
  'opv.promo.mappingHint': 'JSON with "sites", "locations" (bundle reference → this environment’s reference) and "acceptSecurityLevelChange" (bundle references whose security level may differ). Codes only.',
  'opv.promo.mappingInvalid': 'The mapping must be a JSON object.',
  'opv.promo.validate': 'Validate',
  'opv.promo.plan': 'Plan (dry run)',
  'opv.promo.summary': 'Bundle',
  'opv.promo.source': 'Source environment',
  'opv.promo.created': 'Exported',
  'opv.promo.organisation': 'Source organisation',
  'opv.promo.digest': 'Checksum',
  'opv.promo.signed': 'Signed with key {keyId}',
  'opv.promo.unsigned': 'Unsigned',
  'opv.promo.unsignedAccepted': 'Unsigned bundle accepted for review only.',
  'opv.promo.counts': '{sites} sites · {locations} locations ({restricted} restricted) · {policies} visitor policies · {branding} brand settings',
  'opv.promo.skipped': 'Not included',
  'opv.promo.valid': 'Valid',
  'opv.promo.invalid': 'Not valid',
  'opv.promo.problems': 'Problems',
  'opv.promo.planOk': 'No blockers',
  'opv.promo.planBlocked': 'Blocked',
  'opv.promo.blockers': 'Blockers',
  'opv.promo.blockersHint': 'Resolve each blocker by mapping the reference to another location or recording an explicit acceptance in the mapping.',
  'opv.promo.items': 'What would change',
  'opv.promo.col.kind': 'Kind',
  'opv.promo.col.ref': 'Reference here',
  'opv.promo.col.action': 'Change',
  'opv.promo.col.changes': 'Details',
  'opv.promo.kind.site': 'Site',
  'opv.promo.kind.location': 'Location',
  'opv.promo.kind.visitor-policy': 'Visitor policy',
  'opv.promo.kind.security-policy': 'Security policy',
  'opv.promo.kind.branding': 'Branding',
  'opv.promo.action.create': 'Create',
  'opv.promo.action.update': 'Update',
  'opv.promo.action.unchanged': 'Unchanged',
  'specialist.configuration-promoter': 'Configuration promoter (export, validate and plan configuration bundles)',
} as const;
